import { Component, cloneElement, isValidElement } from 'react';
import Alert from './Alert';

/* 0.44.43 - Catches a render crash in ONE element, so one element with
 * bad data (for example an object where a text belongs, React error #31)
 * no longer takes the whole page down with "Page failed to load".
 *
 *   el       the element being drawn (named in the console and, in
 *            admin, in the red box)
 *   admin    true: show a red box naming the element's type and ID and
 *            the error; false (public site): show nothing
 *
 * It adds no box of its own: a className / style given to it (column
 * groups set their children's widths this way) is passed on to the
 * element it wraps, so layouts are unchanged. */
export default class ElementBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const el = this.props.el || {};
    // eslint-disable-next-line no-console
    console.error('[element render error]', 'type=', el.type, 'id=', el.element_id || el.name || el.id,
                  'message=', error && error.message, 'element=', el, info && info.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Editing the element (new data) gets another try.
    if (this.state.error && prevProps.el !== this.props.el) this.setState({ error: null });
  }

  render() {
    const { children, className, style, admin, el } = this.props;
    if (this.state.error) {
      if (!admin) return null;
      const e = el || {};
      return (
        <div className={className} style={style}>
          {/* 0.44.74 - The canonical Henaket alert (admin preview only). */}
          <Alert variant="error"
                 message={`This element could not be shown: type ${String(e.type || 'unknown')}, ID ${String(e.element_id || e.name || e.id || '')}. ${String((this.state.error && this.state.error.message) || '').slice(0, 300)}`} />
        </div>
      );
    }
    if ((className || style) && isValidElement(children)) {
      const cp = children.props || {};
      return cloneElement(children, {
        className: [cp.className || '', className || ''].filter(Boolean).join(' ') || undefined,
        style: { ...(cp.style || {}), ...(style || {}) },
      });
    }
    return children;
  }
}
